export default __webpack_public_path__ + "static/media/thomas-sousa-silva.9ab3ffdc.jpg";